import type { ReactNode } from 'react'

import { Flex, type FlexProps } from 'antd'
import cn from 'classnames'

import styles from './app-flex.module.css'

type TProps = FlexProps & {
  children: ReactNode
  className?: string
}

export const AppFlex = ({ children, className, ...props }: TProps) => (
  <Flex {...props} className={cn(styles.flex, className)}>
    {children}
  </Flex>
)
